import { connect } from 'react-redux'
import at from 'lodash/at'
import get from 'lodash/get'

import { loadCommentsForWorkOrder } from '../../actions/comments'

import WorkOrderComments from '../../components/comments/work-order-comments'

function mapStateToProps (state, ownProps) {
  const id = ownProps.workOrderId

  const workOrder = state.workOrders[id]
  const pagination = get(state, `pagination.commentsByWorkOrder.${id}`, {})
  const comments = at(state.comments, pagination.ids || [])

  return {
    workOrder,
    comments,

    hasNextPage: pagination.nextPageUrl
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(loadCommentsForWorkOrder(ownProps.workOrderId))

  return {
    onLoadNextPage () {
      dispatch(loadCommentsForWorkOrder(ownProps.workOrderId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderComments)



// WEBPACK FOOTER //
// ./src/containers/comments/work-order-comments-container.js